import { render, staticRenderFns } from "./VideoTemplate.vue?vue&type=template&id=6c663d99&"
import script from "./VideoTemplate.vue?vue&type=script&lang=js&"
export * from "./VideoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports